import { useEffect, useState } from "react";
import {
  FormSection,
} from "../FormInput/FormInput";
import InjuredPersonInfo from "./InjuredPersonInfo";

const InjuriesInfoList = ({ formData, handleInputChange, validateForm }) => {
  const [injuredPersonsInfo, setinjuredPersonsInfo] = useState(
    formData.injuriesInLossLists || []
  );

  const addInjuredPerson = () => {
    setinjuredPersonsInfo((prev) => [
      ...prev,
      { id: Date.now(), validate: () => false },
    ]);
  };

  if(injuredPersonsInfo.length == 0)
    addInjuredPerson()

  useEffect(() => {
    if(injuredPersonsInfo.length == 0)
      addInjuredPerson()
  }, [])

  useEffect(() => {
    handleInputChange(
      "injuriesInLossLists", injuredPersonsInfo
    );
  }, [injuredPersonsInfo])

  return (
    <>
        <FormSection header={<div style={{color: "black"}}>Please add all other injured persons below.</div>} setPadding={false}>
            <br/>
            {injuredPersonsInfo.map((data, index) => {
                return (
                <InjuredPersonInfo
                    key={data.id}
                    id={data.id}
                    index={index}
                    data={data}
                    setinjuredPersonsInfo={setinjuredPersonsInfo}
                    canRemove={injuredPersonsInfo.length > 1}
                />
                );
            })}
            <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                className="btn btn-primary btn-sm m-1 px-4 fw-bold text-wrap"
                style={{ borderRadius: "20px" }}
                onClick={addInjuredPerson}
                >
                + Add Another Injured Person Involved in This Loss
                </button>
            </div>
        </FormSection>
    </>
  );
};

export default InjuriesInfoList;
